import store from "../../../store";
import takeaway_export from './takeaway_export.vue';

window.takeaway_export =  new Vue({
    store,
    el: 'div#takeaway_export',

    name : "takeaway_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        takeaway_export,
    }
});
